"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetObjectTaggingInput_1 = require("./GetObjectTaggingInput");
var GetObjectTaggingOutput_1 = require("./GetObjectTaggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetObjectTagging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetObjectTagging",
    http: {
        method: "GET",
        requestUri: "/{Bucket}/{Key+}?tagging"
    },
    input: {
        shape: GetObjectTaggingInput_1.GetObjectTaggingInput
    },
    output: {
        shape: GetObjectTaggingOutput_1.GetObjectTaggingOutput
    },
    errors: []
};
//# sourceMappingURL=GetObjectTagging.js.map